/*
 * Detect when async elements (norton badge, upselly widget) are fully loaded on page.
 * implemented: snippets/product-page-get-info-clear-stix.liquid
 */

document.addEventListener("DOMContentLoaded", function () {

  function whenAvailable(DOM_element, callback, number_of_trys) {
    number_of_trys += 1;
    const appEl = document.querySelector(DOM_element)
    const interval = 1000; 
  
    console.log( number_of_trys)
    const int = window.setTimeout(function() {
        if (appEl) {
            callback(appEl);
            clearInterval(int)
        } else {
           number_of_trys <= 10 ? whenAvailable(DOM_element, callback, number_of_trys) : console.log("Reached limit for number_of_trys", number_of_trys);
        }
    }, interval);
  }
  
  whenAvailable("._GUARANTEE_Kicker_Container", function(el) {
   //console.log("Stylestix video load", el)
   //alert('loaded')
   const stylestixVideo = document.querySelector('[data-js-stylestix-video]')

    if (!el.parentElement) {
      console.log("Can't found parent element for Stylestix video")
      stylestixVideo?.classList?.remove('hide')
      return;
    }

    el.parentElement.classList.add('async-elements__container')

    // 04/17/25 comented due: data-js-stylestix-video-container-desktop was removed from the DOM
    // un-commented -> iframe will be remove element from mobile and desktop will work
    // commented will show element for desktop, not mobile
    // const container = document.createElement('div')
    // container.setAttribute('data-js-stylestix-container', '')
    // el.after(container);

    // append video
    //container.appendChild(stylestixVideo);
    stylestixVideo?.classList?.remove('hide');
    
  }, 0);  
  
})